export default function useAddress() {
  function getAddressString(containableAddressObject: any): string {
    if (!containableAddressObject || !containableAddressObject.province_id) return '';
    if (!containableAddressObject.district_id) return '';
    if (!containableAddressObject.subdistrict_id) return '';
    const key = containableAddressObject.show_as_english ? 'name_in_english' : 'name_in_thai';
    const subDistrict = containableAddressObject.sub_district[key] !== 'NULL' ? containableAddressObject.sub_district[key] : containableAddressObject.sub_district.name_in_thai;
    return `${containableAddressObject.address}${key === 'name_in_english' && containableAddressObject.province_id !== 1 ? ' Tumbol ' : ' '}${subDistrict} ${containableAddressObject.district[key]} ${containableAddressObject.province[key]} ${containableAddressObject.zipcode}`;
  }

  return {
    getAddressString,
  };
}
